const config = {
  "backend-url": process.env.REACT_APP_BACKEND_URL || "http://localhost:3000",
  "socket-url": process.env.REACT_APP_SOCKET_URL || "http://localhost:3000",
  "login-url": process.env.REACT_APP_LOGIN_URL || "http://localhost:3000",
  "primary-color": process.env.REACT_APP_PRIMARY_COLOR || "#002961",
};

export default config;
